import React, { Fragment } from "react";
// import { withRouter } from "react-router-dom";
import { bool } from "prop-types";
import { useDispatch, connect, useSelector } from "react-redux";

import Image from "pages/_components/Image";
import Head from "pages/_components/Head";
import Button from "pages/_components/Button";
import { goBack } from "connected-react-router";
import MainContainer from "pages/_components/MainContainer";
import * as i18nUtils from "util/i18n";
import HeaderSimple from "pages/_components/HeaderSimple/HeaderSimple";
import { selectors as environmentSelectors } from "reducers/environment";
import { Col, Row } from "react-bootstrap";
import CustomText from "pages/_components/CustomText/CustomText";
import { actions as sessionActions } from "reducers/session";
import Notification from "pages/_components/Notification";
import EnvironmentStepper from "../_components/EnvironmentStepper";

const StepError = ({ isMobile }) => {
    const { errorMessage = "" } = useSelector((state) => state.environment);
    const dispatch = useDispatch();
    // const [validateError, setvalidateError] = useState(true);
    const onHeaderBack = () => {
        dispatch(goBack());
    };

    // const goHome = () => {
    //     dispatch(push("/desktop"));
    // };
    const gotLogin = () => {
        dispatch(sessionActions.logout());
    };
    return (
        <Fragment>
            {isMobile ? (
                <Head title="environment.noUser.title" onBack={isMobile && onHeaderBack} />
            ) : (
                <HeaderSimple inverse />
            )}
            <Notification scopeToShow="StepError" />
            <MainContainer className="onboarding">
                <EnvironmentStepper isMobile={isMobile} page="StepError" />
                <div className=" step">
                    <Col xs={12} md={8} mdOffset={2}>
                        <h1 className="text-center">
                            <CustomText text={i18nUtils.get("", "No pudimos finalizar el registro")} />
                        </h1>
                    </Col>
                    <div className="illustration text-center">
                        <Image src="figma/illustrations/onboarding14.svg" className="svg-image logo" />
                    </div>
                    <div className="box box-border-soft">
                        <CustomText
                            text={
                                errorMessage ||
                                i18nUtils.get(
                                    "",
                                    "Comunicate con tu ejecutivo de cuentas para poder revisar las documentaciones enviadas.",
                                )
                            }
                        />
                    </div>

                    <Row className="form-actions no-print">
                        <Col xs={12} md={4} mdOffset={4}>
                            <Button
                                bsStyle="primary"
                                label="global.finalize"
                                loading={false}
                                onClick={() => {
                                    gotLogin();
                                }}
                            />{" "}
                        </Col>
                    </Row>
                </div>
            </MainContainer>
        </Fragment>
    );
};

StepError.propTypes = {
    isMobile: bool.isRequired,
    // currentStepRequest: arrayOf(shape({})).isRequired,
};

const mapStateToProps = (state) => ({
    currentStepRequest: environmentSelectors.getCurrentStepRequest(state),
});

export default connect(mapStateToProps)(StepError);
// export default withRouter(StepError);
